import { Employer } from './employer';
import { Parent } from './parent';
import { Physician } from './physician';
import { Student } from './student';

// Check this class for items that are not truly required
export class ClaimUpdate {
    id?: number;
    parentSeparationDate?: string;
    parentSeparationReason?: string;
    parentId?: string;
    parentSignature?: string;
    parentStudent?: Student;
    parent?: Parent;
    parentPhysician?: Physician;
    parentEmployer?: Employer;
    parentRelocationDate?: string;
}
